import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { User } from '@/entities/user/types';

export type AuthStatus = 'idle' | 'authenticating' | 'authenticated' | 'unauthenticated';

interface AuthState {
  user: User | null;
  accessToken: string | null;
  status: AuthStatus;
}

const initialState: AuthState = {
  user: null,
  accessToken: null,
  status: 'idle',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    sessionStarted(state) {
      state.status = 'authenticating';
    },
    sessionEstablished(
      state,
      action: PayloadAction<{ user: User; accessToken: string | null }>,
    ) {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.status = 'authenticated';
    },
    sessionCleared(state) {
      state.user = null;
      state.accessToken = null;
      state.status = 'unauthenticated';
    },
    sessionFailed(state) {
      state.user = null;
      state.accessToken = null;
      state.status = 'unauthenticated';
    },
    userUpdated(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
  },
});

export const {
  sessionStarted,
  sessionEstablished,
  sessionCleared,
  sessionFailed,
  userUpdated,
} = authSlice.actions;

export const authReducer = authSlice.reducer;
